type ErrorWithMessage = {
  error?: unknown;
  message?: unknown;
  response?: {
    data?: {
      error?: unknown;
      message?: unknown;
    };
  };
};

export const getErrorMessage = (error: unknown, fallbackMessage: string, emptyValue: string | null = fallbackMessage): string | null => {
  if (typeof error === 'string' && error) {
    return error;
  }

  if (!error || typeof error !== 'object') {
    return emptyValue;
  }

  const typedError = error as ErrorWithMessage;

  if (typeof typedError.response?.data?.error === 'string') {
    return typedError.response.data.error;
  }

  if (typeof typedError.response?.data?.message === 'string') {
    return typedError.response.data.message;
  }

  if (typeof typedError.error === 'string') {
    return typedError.error;
  }

  if (typeof typedError.message === 'string') {
    return typedError.message;
  }

  return fallbackMessage;
};
